import ResourcesList from './ResourcesList'

export default ResourcesList
